export class ResetPasswordModel {
  email: string | null;
  newPassword: string | null;
  token: string | null;
  confirmPassword: string | null;
  isEmailOrTokenAbsent?: boolean;
  successfulReset: boolean;
  // Add more fields as needed

  constructor(
    email = "",
    newPassword = "",
    token = "",
    confirmPassword = "",
    successfulReset = false,
    isEmailOrTokenAbsent = false
  ) {
    this.email = email;
    this.newPassword = newPassword;
    this.token = token;
    this.confirmPassword = confirmPassword;
    this.successfulReset = successfulReset;
    this.isEmailOrTokenAbsent = isEmailOrTokenAbsent;
  }
}
